import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IWIICFreeDateProps } from './IWIICFreeDateProps';
import { WIICFreeDateExecutorModal } from './WIICFreeDateExecutorModal';

export const WIICFreeDateExecutor = createDocModalExecutor<IWIICFreeDateProps>({
    modal: WIICFreeDateExecutorModal,
    defaultModalSize: 'm',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        defaultDateField: action.options?.defaultDateField,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
